import React, { FC, useEffect, useState } from 'react';
import TopProgress from '../../../../components/TopBarProgress';
import dashboardService from '../../../../api/dashboardService';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import DoughtnutComponent from './doughnutComponent';
import HypervisorChart from './hypervisorChart';
import InstanceChart from './instanceChart';
import InvoiceInfo from './invoiceInfo';
import SystemInfo from './systemInfo';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend, Title);
const Doughnuts: FC = () => {
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [chartData, setChartData] = useState<any>({ os_labels: [], os_data: [] });
  const [chartDataInstances, setChartDataInstances] = useState<any>({ os_labels: [], os_data: [] });
  const [chartDataFlavors, setChartDataFlavors] = useState<any>({ os_labels: [], os_data: [] });
  const [chartDataHypervisors, setChartDataHypervisors] = useState<any>({ os_labels: [], os_data: [] });
  const [invoiceData, setInvoiceData] = useState<any>({ paid: 0, unpaid: 0, canceled: 0, refunded: 0 });
  const [servicesData, setServicesData] = useState<any>({ celery: false, operations: false, updated: false });
  const [appStatsData, setAppStatsData] = useState<any[]>([]);
  const updateData = async () => {
    try {
      const resOs = await dashboardService.getOperatingSystems();
      const resHypervisors = await dashboardService.getHypervisors()
      const resFlavors = await dashboardService.getFlavors()
      const resInstances = await dashboardService.getInstances()
      const invoiceRes = await dashboardService.getInvoicesSum()
      const servicesRes = await dashboardService.getServicesStatus()
      const appStatsRes = await dashboardService.getAppStats()
      setAppStatsData(Array.isArray(appStatsRes?.data) ? appStatsRes.data : [])
      setInvoiceData(invoiceRes?.data)
      setServicesData(servicesRes?.data)
      setChartData(resOs?.data);
      setChartDataInstances(resInstances?.data)
      setChartDataFlavors(resFlavors?.data)
      setChartDataHypervisors(resHypervisors?.data)
      setPageLoading(false);
    } catch (err: any) {
      console.error('Error fetching operating systems:', err);
      setPageLoading(false);
    }
  };
  const [t] = useTranslation();
  useEffect(() => {
    updateData();
    const interval = setInterval(() => {
      updateData();
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  const theme: any = useTheme();
  const palette = theme?.palette ?? {};
  const backgroundSurface = theme?.isDark ? (palette[20] ?? '#1f2937') : '#f8fafc';

  if (pageLoading) return <TopProgress loading={pageLoading} />;

  const styles = {
    root: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      alignItems: 'flex-start',
      gap: '20px',
      width: '100%',
      boxSizing: 'border-box' as const,
    },
    chartsColumn: {
      flex: '1 1 0',
      minWidth: 'min(320px, 100%)',
      display: 'grid',
      gap: '20px',
      alignContent: 'start',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(260px, 100%), 1fr))',
    },
    infoColumn: {
      flex: '1 1 0',
      minWidth: 'min(280px, 100%)',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '20px',
    },
  };

  return (
    <div style={styles.root}>
      <div style={styles.chartsColumn}>
        <DoughtnutComponent
          labels={chartData?.os_labels}
          data={chartData?.os_data}
          title={t('OS_DISTS')}
          key='os'
        />
        <DoughtnutComponent
          labels={chartDataFlavors?.flavor_labels}
          data={chartDataFlavors?.flavor_data}
          title={t('FLAVORS')}
          key='flavor'
        />
        {chartDataInstances && (
          <InstanceChart instanceData={chartDataInstances} />
        )}
        {chartDataHypervisors?.hypervisors && (
          <HypervisorChart hypervisors={chartDataHypervisors.hypervisors} />
        )}
      </div>

      <div style={styles.infoColumn}>
        {invoiceData && (
          <InvoiceInfo invoiceData={invoiceData} />
        )}
        {servicesData && appStatsData && (
          <SystemInfo servicesData={servicesData} appStatsData={appStatsData} />
        )}
      </div>
    </div>
  );
};

export default Doughnuts;
